import { Phase } from 'components/types';

export const getPhaseString = (phaseNumber: '1' | '2' | '3'): Phase => {
  switch (phaseNumber) {
    case '1':
      return 'Care Planning';
    case '2':
      return 'Treatment';
    case '3':
      return 'Recovery';
  }
};
